export const PROCESS_STATUSES = [
  "draft",
  "submitted",
  "in_review",
  "pending_approval",
  "approved",
  "in_progress",
  "completed",
  "rejected",
];

export const STATUS_STYLES = {
  draft: "bg-slate-700/40 text-slate-300 border-slate-600",
  submitted: "bg-blue-500/15 text-blue-300 border-blue-500/30",
  in_review: "bg-amber-500/15 text-amber-300 border-amber-500/30",
  pending_approval: "bg-purple-500/15 text-purple-300 border-purple-500/30",
  approved: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
  in_progress: "bg-cyan-500/15 text-cyan-300 border-cyan-500/30",
  completed: "bg-emerald-600/25 text-emerald-200 border-emerald-500/40",
  rejected: "bg-red-500/15 text-red-300 border-red-500/30",
};

export const DOC_STATUS_STYLES = {
  required: "bg-slate-700/40 text-slate-300 border-slate-600",
  uploaded: "bg-blue-500/15 text-blue-300 border-blue-500/30",
  approved: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
  rejected: "bg-red-500/15 text-red-300 border-red-500/30",
};

export const formatDateTime = (iso, locale) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString(locale || undefined, {
      dateStyle: "medium",
      timeStyle: "short",
    });
  } catch (e) {
    return iso;
  }
};
